<template>
  <div>
    <van-sticky>
      <navbar :title="title" />
      <van-search
        v-model="form.order_name"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      ></van-search>
    </van-sticky>

    <van-list
      v-model="list.loading"
      :finished="list.finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="60"
      style="padding-bottom: 50px"
      class="list-content"
    >
      <div
        class="item-list"
        v-for="item in list.list"
        :key="item.recede_id"
        @click="reviewDetails(item.recede_id)"
      >
        <div class="product-bh-cont">
          <van-icon name="todo-list-o" />
          <span class="product-bh">{{item.recede_id}}订单编号:{{ item.order_code }}</span>
        </div>
        <div class="text-title">项目名称：{{ item.order_name }}</div>
        <div class="text-title">单位名称：{{ item.client_name }}</div>
        <div class="text-price">
          <span>退货数量：{{ item.recede_quantity }}</span>
          <span>退款金额：¥{{ item.recede_amount }}</span>
        </div>
        <div class="text-time">{{ item.create_date }}</div>
        <van-tag
          class="item-tag"
          plain
          :type="tagPrimary[item.check_status].value"
          >{{ tagPrimary[item.check_status].text }}</van-tag
        >
      </div>
    </van-list>

    <van-tabbar v-model="activeName">
      <van-tabbar-item name="list" icon="clock-o" to="/returnManagement"
        >退货列表</van-tabbar-item
      >
      <van-tabbar-item
        name="approval"
        icon="upgrade"
        to="/returnManagement/audit"
        >我的审核</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { post } from "@/api/post";

export default {
  components: {
    navbar,
  },
  data() {
    return {
      activeName: "approval",
      title: "退货审核",
      form: {
        requestType: "sales_check_list",
        page: 1,
        limit: 10,
        order_name: "",
      },
      list: {
        list: [],
        loading: false,
        finished: false,
      },
      tagPrimary: [
        { text: "董事长审核", value: "default" },
        { text: "仓库审核", value: "primary" },
        { text: "财务审核", value: "primary" },
        { text: "已通过", value: "success" },
        { text: "已驳回", value: "warning" },
      ],
    };
  },
  activated() {
    if (this.$route.params.refresh != true) {
      this.list.list = [];
      this.activeName = "list";
      this.list.finished = false;
      this.form.page = 1;
      this.form.approval_status = 0;
      this.list.user_name = "";
      this.onLoad();
    }
  },
  methods: {
    activated() {
      if (!this.$route.meta.isBack || this.isFirstEnter) {
        this.onLoad();
      }
      this.$route.meta.isBack = false;
      this.isFirstEnter = false;
    },
    onSearch() {
      this.list.list = [];
      this.form.page = 1;
      this.list.finished = false;
      this.onLoad();
    },
    onLoad() {
      post(this.form)
        .then((res) => {
          if (res.obj.rows.length === 0) {
            this.list.finished = true;
          }
          if (this.form.page != 1) {
            this.list.list = this.list.list.concat(res.obj.rows);
          } else {
            this.list.list = res.obj.rows;
          }

          this.form.page += 1;
          this.list.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.list.loading = false;
          this.list.finished = true;
          return Toast.fail("数据异常");
        });
    },
    reviewDetails(recede_id) {
      this.$router.push({
        path: "/returnManagement/details",
        query: { id: recede_id, p: true },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-content {
  padding: 0 10px;
  .item-list {
    margin: 10px 0;
    padding: 1rem 1.14286rem;
    border-radius: 10px;
    background: #fff;
    position: relative;
    .product-bh-cont {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .product-bh {
        color: #999;
        font-size: 12px;
        margin-left: 5px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }
    .text-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      font-size: 13px;
    }
    .item-tag {
      position: absolute;
      right: 15px;
      bottom: 10px;
    }
    .text-price {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      span {
        font-size: 12px;
        font-weight: bold;
      }
    }
    .text-time {
      margin-top: 8px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
